import React, { useState } from 'react'
import './App.css';
import { CircularProgress, debounce, Grid } from '@material-ui/core';
import ProductOptions from './components/ProductOptions';
import Categories from './components/Categories';
import ProductReviews from './components/ProductReviews';
import ProductDetails from './components/ProductDetails';
import Products from './components/Products';

const Mobile = (props) => {
  const [selectedCategorySlug, setSelectedCategorySlug] = useState('');
  const [selectedProduct, setSelectedProduct] = useState('');
  
  return (
    <>
      <Grid container direction="column" justifyContent="center" alignItems="center" style={{ minHeight: '300px' }}>
        <Categories {...props} selectedCallback={setSelectedCategorySlug} />
        <Products {...props} isMobile={true} categorySlug={selectedCategorySlug} selectedCallback={setSelectedProduct} />
        {
          !selectedProduct ?
            <Grid style={{ minHeight: '200px' }} item><CircularProgress color="inherit" /></Grid>
            : null
        }
        <Grid item>
          <ProductDetails isMobile={true} product={selectedProduct} />
        </Grid>
        <Grid item style={{marginBottom: '20px', paddingBottom: '20px', width: '100%'}}>
          <ProductReviews {...props} product={selectedProduct} productID={selectedProduct.id} />
        </Grid>
        <Grid item xs style={{alignSelf: 'stretch'}}>
          <ProductOptions {...props} isMobile={true} categorySlug={selectedCategorySlug} product={selectedProduct} />
        </Grid>
      </Grid>
    </>
  );
}

export default Mobile;
